import './App.css';
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Home from './Home';
import HomeSv from './HomeSv';
import Kaivuutyot from './Kaivuutyot';
import KaivuutyotSv from './KaivuutyotSv';
import Kivityot from './Kivityot';
import KivityotSv from './KivityotSv';
import Rakennustyot from './Rakennustyot';
import RakennustyotSv from './RakennustyotSv';
import Sahkotyot from './Sahkotyot';
import SahkotyotSv from './SahkotyotSv';

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/sv" element={<HomeSv />} />
        <Route path="/kaivuutyot" element={<Kaivuutyot />} />
        <Route path="/sv/kaivuutyot" element={<KaivuutyotSv />} />
        <Route path="/kivityot" element={<Kivityot />} />
        <Route path="/sv/kivityot" element={<KivityotSv />} />
        <Route path="/rakennustyot" element={<Rakennustyot />} />
        <Route path="/sv/rakennustyot" element={<RakennustyotSv />} />
        <Route path="/sahkotyot" element={<Sahkotyot />} />
        <Route path="/sv/sahkotyot" element={<SahkotyotSv />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;

